"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.DefaultContext = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined,
};
exports.IconContext = React.createContext && React.createContext(exports.DefaultContext);



//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/cjs/iconContext.js
// module id = 140
// module chunks = 0